import React, {  useEffect } from "react";
import * as sweetalert from "sweetalert";
import {  useNavigate } from "react-router-dom";
import axios from "axios";
import { Grid } from "@material-ui/core";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function ProviderSetting() {
  const navigate = useNavigate();
  const initialFValues = {
    userName: "",
    password: "",
    DistributorCode: "",
 
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

    if ("user_name" in fieldValues)
      temp.user_name = fieldValues.user_name ? "" : "هذا الحقل  مطلوب";
    if ("location" in fieldValues)
      temp.location = fieldValues.location ? "" : "هذا الحقل مطلوب";
    if ("gsm" in fieldValues) {
        if (fieldValues.gsm == "") {
          temp.gsm = " رقم الموبايل مطلوب";
        } else if (!/[0-9]/.test(fieldValues.gsm)) {
          temp.gsm = "يجب أن يكون رقم الموبايل أرقام";
        } else {
          temp.gsm = "";
        }
  
      }

      // if ("password" in fieldValues) {
      //   if (fieldValues.password == "") {
      //     temp.password = "كلمة السر مطلوبة";
      //   } else if (fieldValues.password.length < 8) {
      //     temp.password = "يجب ان تكون ثماني محارف";
      //   } else {
      //     temp.password = "";
      //   }
      // }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    addForm,
  } = useForm(initialFValues, true, validate);
  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/config`, {
        withCredentials: true,
      })
      .then((res) => {
        setLogin({
          userName: res.data.data.userNameMtn,
          DistributorCode: res.data.data.DistributorCodeMtn,
          password: res.data.data.passwordMtn,
     
        });
      })
      .catch((err) => {});
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
    
      const bodyFormData = new FormData();
      bodyFormData.append("userName", loginInput.userName);
      bodyFormData.append("DistributorCode", loginInput.DistributorCode);
      bodyFormData.append("password", loginInput.password);
      axios
        .post(`${BaseUrl}/api/addConfig`, bodyFormData, {
          withCredentials: true,
        })
        .then((res) => {
     
          if (res.status == "200") {
            sweetalert("تم التعديل بنجاح", {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }
            );
            navigate("/providers-mtn");
          } else {
            sweetalert(loginInput.error_list);
            setLogin({ ...loginInput, error_list: res.data.message });

          
          }
        });
    }   
    };
  return (
    <div className="main-div">
    
      <h3 className="titlepage">إعدادات نقطة البيع</h3>


      <Form className="form-group new-design" method="post"
        enctype="multipart/form-data" onSubmit={handleSubmit}>
        <Grid container maxWidth="sm" spacing={4}>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="اسم المستخدم"
              name="userName"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              value={loginInput.userName}
              className="form-control"
              error={errors.userName}
              type="text"
            />
          </Grid>
   
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="كود الموزع"
              name="DistributorCode"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              value={loginInput.DistributorCode}
              className="form-control"
              error={errors.DistributorCode}
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="كلمة المرور"
              name="password"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              value={loginInput.password}
              className="form-control"
              error={errors.password}
              type="text"
            />
          </Grid>
        </Grid>
        
          <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          <Controls.Button
            type="submit"
            text="حفظ"
            onClick={addForm}
            variant="contained"
            className="btn-submit"
          ></Controls.Button>
        </Grid>
      
     
      </Form>
    </div>
  );
}
